import {
  parseAsInteger,
  parseAsStringLiteral,
  useQueryStates,
  createParser,
} from 'nuqs'
import { format, isValid, parse } from 'date-fns'
import { WorkerEvaluationReviewStatus } from 'api/review/getWorkReview'

const parseAsLocalDate = createParser<Date>({
  parse(queryValue: string) {
    const parsedDate = parse(queryValue, 'yyyy-MM-dd', new Date())
    if (!isValid(parsedDate)) {
      return null
    }
    return parsedDate
  },
  serialize(value: Date) {
    return format(value, 'yyyy-MM-dd')
  },
  eq(a: Date, b: Date) {
    return a.getTime() === b.getTime()
  },
})

const reviewStatusValues: WorkerEvaluationReviewStatus[] = [
  'all',
  'pending_review',
  'reviewed',
]

export function useReviewEvaluateV2FilterQueryState() {
  return useQueryStates(
    {
      reviewStatus:
        parseAsStringLiteral(reviewStatusValues).withDefault('pending_review'),
      from: parseAsLocalDate,
      to: parseAsLocalDate,
      locationId: parseAsInteger,
      positionId: parseAsInteger,
      workerId: parseAsInteger,
    },
    {
      urlKeys: {
        reviewStatus: 'status',
        from: 'from',
        to: 'to',
        locationId: 'location-id',
        positionId: 'position-id',
        workerId: 'worker-id',
      },
    }
  )
}
